import RoutesMap from '../../route_control/RouteControl'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown } from 'antd'
import img_nf from '../../assets/images/default.jpg'
import dayjs from 'dayjs'
import { ChangePassword } from '../../pages/user'
import { SessionManager, isStudent } from '../../utils'
import { KeyRound, Languages, ListCollapse, Power, UserPen } from 'lucide-react'
import { toggleChangePasswordModal } from '../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export const HeaderImport = {
    RoutesMap,
    useNavigate,
    useDispatch,
    useSelector,
    Dropdown,
    img_nf,
    dayjs,
    ChangePassword,
    SessionManager,
    isStudent,
    KeyRound,
    Languages,
    ListCollapse,
    Power,
    UserPen,
    toggleChangePasswordModal,
    useTranslation
}